import { getSigninAuthTokenForApi } from "@/lib/signinPendingAuth";

/**
 * อ่าน user id จาก JWT (committed หรือ pending ระหว่างสร้าง workspace)
 */
export function getUserIdFromAuthToken(): string | undefined {
  if (typeof window === "undefined") return undefined;
  const raw = getSigninAuthTokenForApi();
  if (!raw) return undefined;
  const token = raw.startsWith("Bearer ") ? raw.slice(7) : raw;
  try {
    const parts = token.split(".");
    if (parts.length !== 3) return undefined;
    let b64 = parts[1].replace(/-/g, "+").replace(/_/g, "/");
    const pad = b64.length % 4;
    if (pad) b64 += "=".repeat(4 - pad);
    const payload = JSON.parse(atob(b64)) as Record<string, unknown>;
    const uid =
      (typeof payload.userId === "string" && payload.userId) ||
      (typeof payload.sub === "string" && payload.sub) ||
      (typeof payload.id === "string" && payload.id);
    return uid || undefined;
  } catch {
    return undefined;
  }
}
